// Mock character names for the SafePorter superadmin test bench.
// Provides 100 civilian identities drawn from Marvel, DC, and Disney/Pixar
// so generated test employees have recognisable, non-sensitive names.

export const CHARACTERS = [
    // --- Tier 1: Marvel (~40) ---
    { first: 'Bruce',    last: 'Banner' },
    { first: 'Tony',     last: 'Stark' },
    { first: 'Steve',    last: 'Rogers' },
    { first: 'Natasha',  last: 'Romanoff' },
    { first: 'Peter',    last: 'Parker' },
    { first: 'Wanda',    last: 'Maximoff' },
    { first: 'Carol',    last: 'Danvers' },
    { first: 'Matt',     last: 'Murdock' },
    { first: 'Wade',     last: 'Wilson' },
    { first: 'Jessica',  last: 'Jones' },
    { first: 'Luke',     last: 'Cage' },
    { first: 'Ororo',    last: 'Munroe' },
    { first: 'Scott',    last: 'Lang' },
    { first: 'Hank',     last: 'Pym' },
    { first: 'Janet',    last: 'Van Dyne' },
    { first: 'Bucky',    last: 'Barnes' },
    { first: 'Sam',      last: 'Wilson' },
    { first: 'Pepper',   last: 'Potts' },
    { first: 'Virginia', last: 'Potts' },
    { first: 'Jean',     last: 'Grey' },
    { first: 'Scott',    last: 'Summers' },
    { first: 'Logan',    last: 'Howlett' },
    { first: 'Raven',    last: 'Darkholme' },
    { first: 'Charles',  last: 'Xavier' },
    { first: 'Erik',     last: 'Lehnsherr' },
    { first: 'Remy',     last: 'LeBeau' },
    { first: 'Anna',     last: 'Marie' },
    { first: 'Felicia',  last: 'Hardy' },
    { first: 'Frank',    last: 'Castle' },
    { first: 'Danny',    last: 'Rand' },
    { first: 'Kamala',   last: 'Khan' },
    { first: 'Shuri',    last: 'Udaku' },
    { first: 'Gwen',     last: 'Stacy' },
    { first: 'Miles',    last: 'Morales' },
    { first: 'Stephen',  last: 'Strange' },
    { first: 'Pietro',   last: 'Maximoff' },
    { first: 'Clint',    last: 'Barton' },
    { first: 'Hope',     last: 'Van Dyne' },
    { first: 'Monica',   last: 'Rambeau' },
    { first: 'Yelena',   last: 'Belova' },

    // --- Tier 2: DC (~35) ---
    { first: 'Bruce',    last: 'Wayne' },
    { first: 'Diana',    last: 'Prince' },
    { first: 'Clark',    last: 'Kent' },
    { first: 'Barry',    last: 'Allen' },
    { first: 'Selina',   last: 'Kyle' },
    { first: 'Victor',   last: 'Stone' },
    { first: 'Arthur',   last: 'Curry' },
    { first: 'Hal',      last: 'Jordan' },
    { first: 'Barbara',  last: 'Gordon' },
    { first: 'Harleen',  last: 'Quinzel' },
    { first: 'Edward',   last: 'Nygma' },
    { first: 'Pamela',   last: 'Isley' },
    { first: 'Victor',   last: 'Fries' },
    { first: 'Oswald',   last: 'Cobblepot' },
    { first: 'Oliver',   last: 'Queen' },
    { first: 'Dinah',    last: 'Lance' },
    { first: 'John',     last: 'Constantine' },
    { first: 'Kara',     last: 'Zor-El' },
    { first: 'Dick',     last: 'Grayson' },
    { first: 'Jason',    last: 'Todd' },
    { first: 'Tim',      last: 'Drake' },
    { first: 'Damian',   last: 'Wayne' },
    { first: 'Helena',   last: 'Bertinelli' },
    { first: 'Zatanna',  last: 'Zatara' },
    { first: 'John',     last: 'Stewart' },
    { first: 'Kyle',     last: 'Rayner' },
    { first: 'Wally',    last: 'West' },
    { first: 'Iris',     last: 'West' },
    { first: 'Lois',     last: 'Lane' },
    { first: 'Jimmy',    last: 'Olsen' },
    { first: 'Garfield', last: 'Logan' },
    { first: 'Rachel',   last: 'Roth' },
    { first: "Koriand'r", last: 'Anders' },
    { first: 'Slade',    last: 'Wilson' },
    { first: 'Floyd',    last: 'Lawton' },

    // --- Tier 3: Disney / Pixar (~25) ---
    { first: 'Moana',      last: 'Waialiki' },
    { first: 'Mirabel',    last: 'Madrigal' },
    { first: 'Rapunzel',   last: 'Corona' },
    { first: 'Merida',     last: 'DunBroch' },
    { first: 'Tiana',      last: 'Broussard' },
    { first: 'Mulan',      last: 'Hua' },
    { first: 'Jasmine',    last: 'Agrabah' },
    { first: 'Pocahontas', last: 'Powhatan' },
    { first: 'Ariel',      last: 'Triton' },
    { first: 'Belle',      last: 'Villeneuve' },
    { first: 'Elsa',       last: 'Arendelle' },
    { first: 'Anna',       last: 'Arendelle' },
    { first: 'Raya',       last: 'Kumandra' },
    { first: 'Nala',       last: 'Pride' },
    { first: 'Megara',     last: 'Thebes' },
    { first: 'Esmeralda',  last: 'Notre' },
    { first: 'Aurora',     last: 'Briar' },
    { first: 'Cinderella', last: 'Tremaine' },
    { first: 'Snow',       last: 'White' },
    { first: 'Alice',      last: 'Liddell' },
    { first: 'Wendy',      last: 'Darling' },
    { first: 'Lilo',       last: 'Pelekai' },
    { first: 'Nani',       last: 'Pelekai' },
    { first: 'Violet',     last: 'Parr' },
    { first: 'Helen',      last: 'Parr' },
]

// ---------------------------------------------------------------------------
// nextEmailNumber(existingRows)
// Scans all string values in existing rows for shoshana+N@safeportersecure.com
// and returns the lowest unused N >= 1.
// ---------------------------------------------------------------------------
export function nextEmailNumber(existingRows) {
    const used = new Set()
    const pattern = /shoshana\+(\d+)@safeportersecure\.com/i
    ;(existingRows || []).forEach(row => {
        Object.values(row || {}).forEach(val => {
            if (typeof val === 'string') {
                const m = val.match(pattern)
                if (m) used.add(parseInt(m[1], 10))
            }
        })
    })
    let n = 1
    while (used.has(n)) n++
    return n
}

// ---------------------------------------------------------------------------
// nextEmployeeId(existingRows)
// Scans Employee_ID / employee_id fields and returns the next unused id >= 1001.
// ---------------------------------------------------------------------------
export function nextEmployeeId(existingRows) {
    const used = new Set()
    ;(existingRows || []).forEach(row => {
        const raw = row?.Employee_ID ?? row?.employee_id
        if (raw !== undefined && raw !== null && raw !== '') {
            const n = parseInt(raw, 10)
            if (!isNaN(n)) used.add(n)
        }
    })
    let id = 1001
    while (used.has(id)) id++
    return id
}

// ---------------------------------------------------------------------------
// pickCharacter(existingRows)
// Returns the first CHARACTERS entry whose first+last combo is not already
// present in existing rows.  Falls back to { first: 'Test', last: 'User<N>' }
// when all 100 have been used.
// ---------------------------------------------------------------------------
export function pickCharacter(existingRows) {
    const taken = new Set(
        (existingRows || []).map(row => {
            // Match against any field that looks like a first/last name pair
            const first = Object.entries(row || {}).find(([k]) => /first.?name|^first$/i.test(k))?.[1] || ''
            const last  = Object.entries(row || {}).find(([k]) => /last.?name|^last$/i.test(k))?.[1] || ''
            return `${first}|${last}`
        })
    )

    for (const char of CHARACTERS) {
        if (!taken.has(`${char.first}|${char.last}`)) return char
    }

    // All 100 exhausted — generate a safe fallback
    const n = (existingRows || []).length - CHARACTERS.length + 1
    return { first: 'Test', last: `User${n}` }
}

// ---------------------------------------------------------------------------
// generateMockEmployee(columns, existingRows, locationKeys, datamap)
// Creates one fully-populated mock employee row keyed by Workday column names.
// ---------------------------------------------------------------------------
export function generateMockEmployee(columns, existingRows, locationKeys, datamap) {
    const character = pickCharacter(existingRows)
    const emailNum  = nextEmailNumber(existingRows)
    const empId     = nextEmployeeId(existingRows)
    const locations = Array.isArray(locationKeys) ? locationKeys.filter(Boolean) : []

    const row = {}
    ;(columns || []).forEach(col => {
        const label = (datamap && datamap[col]) || ''
        const haystack = `${col} ${label}`

        if (/email/i.test(haystack)) {
            row[col] = `shoshana+${emailNum}@safeportersecure.com`
        } else if (/first.?name|^first$/i.test(haystack)) {
            row[col] = character.first
        } else if (/last.?name|^last$/i.test(haystack)) {
            row[col] = character.last
        } else if (/employee.?id|\bid\b/i.test(haystack)) {
            row[col] = String(empId)
        } else if (/location/i.test(haystack)) {
            row[col] = locations.length
                ? locations[Math.floor(Math.random() * locations.length)]
                : ''
        } else {
            row[col] = ''
        }
    })

    return row
}
